export const POSITION_TYPES = [
  {
    label: 'Job',
    value: 'JOB',
  },
  {
    label: 'Internship',
    value: 'INTERNSHIP',
  },
  {
    label: 'Volunteer',
    value: 'VOLOP',
  },
];
